<div class="modal-body" [formGroup]="form">
  <div class="panel-item">
    <label class="panel-label">Телефон</label>
    <input prefix="+7" mask=" (000) 000 00 00" type="text" class="panel-input" formControlName="login" placeholder="Введите ваш номер">
  </div>
  <app-button
    [buttonClass]="'big-purple-gradient'"
    [text]="'Продолжить'"
    [styleInline]="{ 'height': '100%' }"
    [disabled]="form.invalid || isSendPhone"
    (buttonClick)="fetchPhone()"
  ></app-button>
</div>